/* eslint no-extend-native: "off" */

/**
 * When executed, this function applies polyfills to the following functionalities:
 * Function.prototype.bind,
 * Object.assign,
 * Object.create,
 * Array.prototype.forEach,
 * Array.isArray
 *
 * @memberof youbora
 */
var applyPolyfills = function () {
  // Bind
  Function.prototype.bind = Function.prototype.bind || function (b) {
    if (typeof this !== 'function') {
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable')
    }
    var a = Array.prototype.slice
    var f = a.call(arguments, 1)
    var e = this
    var C = function () {}
    var d = function () {
      return e.apply(this instanceof C ? this : b || window, f.concat(a.call(arguments)))
    }
    C.prototype = this.prototype
    d.prototype = new C()
    return d
  }

  // Assign
  Object.assign = Object.assign || function (target) {
    if (target === undefined || target === null) {
      throw new TypeError('Cannot convert undefined or null to object')
    }

    var output = Object(target)
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index]
      if (source !== undefined && source !== null) {
        for (var nextKey in source) {
          if (source.hasOwnProperty(nextKey)) {
            output[nextKey] = source[nextKey]
          }
        }
      }
    }
    return output
  }

  // Create
  Object.create = Object.create || (function () {
    var Temp = function () {}
    return function (prototype, propertiesObject) {
      if (prototype !== Object(prototype) && prototype !== null) {
        throw TypeError('Argument must be an object, or null')
      }
      Temp.prototype = prototype || {}
      var result = new Temp()
      Temp.prototype = null
      if (propertiesObject !== undefined) {
        Object.defineProperties(result, propertiesObject)
      }

      // to imitate the case of Object.create(null)
      if (prototype === null) {
        result.prototype = null
      }
      return result
    }
  })()

  // Foreach
  Array.prototype.forEach = Array.prototype.forEach || function (callback, thisArg) {
    if (typeof (callback) !== 'function') {
      throw new TypeError(callback + ' is not a function!')
    }
    var len = this.length
    for (var i = 0; i < len; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }

  // isArray
  Array.isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  }
}

module.exports = applyPolyfills



//////////////////
// WEBPACK FOOTER
// ./src/polyfills.js
// module id = 21
// module chunks = 0